// Shared lookup status enum, badge props, and filter options

export type LookupStatus = 'draft' | 'processing' | 'processing_error' | 'review' | 'active' | 'archived';

export const LOOKUP_STATUSES: LookupStatus[] = ['draft', 'processing', 'processing_error', 'review', 'active', 'archived'];

export const getStatusBadgeProps = (status: LookupStatus) => {
  const map: Record<LookupStatus, { colorPalette: string; label: string }> = {
    draft: { colorPalette: 'gray', label: 'Draft' },
    processing: { colorPalette: 'yellow', label: 'Processing' },
    processing_error: { colorPalette: 'red', label: 'Processing Error' },
    review: { colorPalette: 'blue', label: 'Review' },
    active: { colorPalette: 'green', label: 'Active' },
    archived: { colorPalette: 'red', label: 'Archived' },
  };
  return map[status] ?? { colorPalette: 'gray', label: status };
};

/** Options for filter dropdowns (includes "All" sentinel) */
export const LOOKUP_STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'All Status' },
  ...LOOKUP_STATUSES.map((s) => ({ value: s, label: getStatusBadgeProps(s).label })),
];

/** Options for form selects (no "All" sentinel) */
export const LOOKUP_STATUS_OPTIONS = LOOKUP_STATUSES.map((s) => ({
  value: s,
  label: getStatusBadgeProps(s).label,
}));
